import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "width-100 flex items-center justify-between",
  "data-ts": "footer-pagination"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  class: "ml-2",
  "data-ts": "items-per-page"
}
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "ml-6 mr-2" }
const _hoisted_6 = { class: "mx-4" }
const _hoisted_7 = { class: "text-weight-bold" }

import { ref, computed } from 'vue';
import Btn from '../Btn/Btn.vue';
import SelectBox from '../SelectBox/SelectBox.vue';
import BtnIcon from '../BtnIcon/BtnIcon.vue';
import InputField from '../InputField/InputField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterPagination',
  props: {
    currentLimit: {},
    currentPage: {},
    disabledLimitSelector: { type: Boolean },
    goToPageLabel: {},
    itemsPerPageLabel: {},
    totalNumberOfItems: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const LIMIT_OPTIONS = [
	{ value: 10, label: '10' },
	{ value: 25, label: '25' },
	{ value: 50, label: '50' },
];

const props = __props;

const emit = __emit;

const pageInput = ref(1);

const computedNumberOfPages = computed(() => {
	return Math.ceil(Number(props.totalNumberOfItems) / Number(props.currentLimit));
});

const handleChange = (selectedPage: number, selectedLimit: number) => {
	if (selectedPage > computedNumberOfPages.value || selectedPage <= 0) return;

	emit('change', { page: selectedPage, limit: selectedLimit });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBox, {
        "dropdown-position-top": "",
        "data-ts": "footer-pagination--select-box",
        options: LIMIT_OPTIONS,
        disabled: _ctx.disabledLimitSelector,
        "selected-value": _ctx.currentLimit,
        onSelect: _cache[0] || (_cache[0] = ($event: any) => (handleChange(1, $event)))
      }, null, 8, ["disabled", "selected-value"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.itemsPerPageLabel), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(props.goToPageLabel), 1),
      _createVNode(InputField, {
        style: {"width":"60px"},
        placeholder: _ctx.currentPage?.toString() || '1',
        type: "number",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (pageInput.value = $event)),
        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (handleChange(pageInput.value, _ctx.currentLimit)), ["enter"]))
      }, null, 8, ["placeholder"]),
      _createVNode(Btn, {
        variant: "secondary",
        label: "Go",
        class: "ml-2 mr-8",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChange(pageInput.value, _ctx.currentLimit)))
      }),
      _createVNode(BtnIcon, {
        ariaLabel: "Go to previous page",
        "icon-name": "bx-chevron-left",
        variant: "secondary",
        disabled: _ctx.currentPage === 1,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleChange(Number(_ctx.currentPage) - 1, _ctx.currentLimit)))
      }, null, 8, ["disabled"]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentPage), 1),
        _createTextVNode(" / " + _toDisplayString(computedNumberOfPages.value), 1)
      ]),
      _createVNode(BtnIcon, {
        ariaLabel: "Go to next page",
        "icon-name": "bx-chevron-right",
        variant: "secondary",
        "data-test": "next-page-btn",
        disabled: _ctx.currentPage === computedNumberOfPages.value,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleChange(Number(_ctx.currentPage) + 1, _ctx.currentLimit)))
      }, null, 8, ["disabled"])
    ])
  ]))
}
}

})